export type DbSyncSubscriptionAdditionalData = {
    currentUserId?: string;
    isInitialSync?: boolean;
};

export type DbSyncSubscription = {
    getQuery: (nextToken: string | undefined, meta: DbSyncSubscriptionAdditionalData) => string;
    nextTokenGetter?: (result: any, meta: DbSyncSubscriptionAdditionalData) => string | undefined;
    key: string;
    onNewItems: (item: any[]) => Promise<void>;
};

export type WrappedHandler<T extends {}> = { start: () => Promise<void> } & ((items: T[]) => Promise<void>);
export const wrapHandlerWithAccumulator = <T extends {}>(handler: (items: T[]) => Promise<void>): WrappedHandler<T> => {
    const accumulator: T[] = [];
    let resolver: () => void;
    let rejecter: (params: any) => void;
    let promise = new Promise<void>((resolve, reject) => {
        resolver = resolve;
        rejecter = reject;
    });
    const wrap = (items: T[]) => {
        accumulator.push(...items);
        return promise;
    };
    wrap.start = async (): Promise<void> => {
        try {
            if (accumulator.length) {
                await handler(accumulator);
            }
            resolver();
        } catch (e) {
            rejecter(e);
            throw e;
        }
    };

    return wrap;
};

export type SyncableTable =
    | 'aircraftMaintenanceLimitExtensions'
    | 'aircrafts'
    | 'contacts'
    | 'countableChanges'
    | 'documents'
    | 'dutyItems'
    | 'flightExpenses'
    | 'flights'
    | 'legs'
    | 'logbookRecords'
    | 'releaseToServices'
    | 'signedData'
    | 'signingKeyChanges'
    | 'squawkDeferrals'
    | 'squawks';

export type SyncItem = {
    id: string;
    tableName: SyncableTable;
    itemId: string;
};

// Mutation generation for writes lives in @eflight/shared (the mcpServer lambda uses it too).
export {
    type DbSyncerUpCommand,
    type DbSyncerUpDefinition,
    getStandardSyncerFields,
    syncUpCommandsToMutation,
} from '@eflight/shared/dist/common/syncUp';
